// Registry of preference keys. Every key stored through useUserPrefString /
// useUserPrefNumber must come from here so the Preferences dialog can label it.

export type UserPrefKind = "string" | "number" | "tab";

export type UserPrefDef = {
    // exact key, or key prefix when `prefix` is true (e.g. "default-tab:")
    key: string;
    prefix?: boolean;
    label: string;
    description: string;
    kind: UserPrefKind;
}

export const defaultTabPrefix = "default-tab:";

export function defaultTabKey(page: string) {
    return defaultTabPrefix + page;
}

// Stable page keys for useDefaultTab / useTabQueryParam, with the label the
// Preferences dialog shows. Never rename a key: stored preferences reference it.
export const defaultTabPages = {
    "shopdrawing.openings": "Shop Drawing · Openings",
    "shopdrawing.hardware": "Shop Drawing · Hardware",
    "shopdrawing.pricing": "Shop Drawing · Pricing",
    "shopdrawing.logistics": "Shop Drawing · Logistics",
    "shopdrawing.misc": "Shop Drawing · Misc",
    "quote.openings": "Quote · Openings",
    "quote.hardware": "Quote · Hardware",
    "project.manage": "Project · Overview section",
    "finance.payables": "Finance · Bills",
    "finance.receivables": "Finance · Invoices",
    "logistics.purchasing": "Logistics · Purchasing",
    "logistics.receiving": "Logistics · Receiving",
    "manufacturing.po": "Manufacturing · Purchase Order",
    "settings.products": "Settings · Products section",
    "settings.products.list": "Settings · Products list",
    "settings.customers": "Settings · Customers",
};

export type DefaultTabPage = keyof typeof defaultTabPages;

export const userPrefDefs: UserPrefDef[] = [
    {
        key: defaultTabPrefix,
        prefix: true,
        label: "Default tabs",
        description: "The tab that opens first on a page. Right-click a tab and choose \"Set as default tab\" to set this.",
        kind: "tab",
    },
];

export function findUserPrefDef(key: string): UserPrefDef | null {
    return userPrefDefs.find(d => d.prefix ? key.startsWith(d.key) : key === d.key) || null;
}

export function describeUserPrefKey(key: string): string {
    if (key.startsWith(defaultTabPrefix)) {
        const page = key.substring(defaultTabPrefix.length);
        return (defaultTabPages as {[k: string]: string})[page] || page;
    }

    return key;
}
